import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Nav() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation(); // To access the current route

  // Function to check if the current route matches the link
  const getLinkClass = (path) => {
    return location.pathname === path
      ? "bg-white text-black py-2 px-4 transition duration-300 rounded-lg shadow-xl font-bold" // Active link styles (white background)
      : "hover:bg-white hover:text-black py-2 px-4 transition duration-300 rounded-lg hover:shadow-xl font-bold"; // Hover styles for non-active links
  };

  return (
    <nav className="bg-gradient-to-r from-orange-400 via-red-500 to-pink-500 text-white flex items-center justify-between px-6 py-4 rounded-b-3xl shadow-lg">
      {/* Brand Logo */}
      <div className="flex items-center">
        <Link to="/" className="flex items-center">
          <img
            src="/nuvia.png" // Path from public directory
            alt="Brand Logo"
            className="h-10 w-auto"
          />
        </Link>
      </div>

      {/* Navigation Links */}
      <div className="hidden md:flex flex-grow justify-center space-x-6">
        <Link to="/" className={getLinkClass("/")}>
          Home
        </Link>
        <Link to="/products" className={getLinkClass("/products")}>
          Products
        </Link>
        <Link to="/orders" className={getLinkClass("/orders")}>
          My Orders
        </Link>
        <Link to="/go-pro" className={getLinkClass("/go-pro")}>
          Get Nuvia Pro
        </Link>
      </div>

      {/* Hamburger Menu Button */}
      <button
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        className="block md:hidden text-white text-2xl p-2 focus:outline-none"
      >
        {isMenuOpen ? "x" : "☰"} {/* Show X when menu is open, hamburger otherwise */}
      </button>

      {/* Mobile Dropdown Menu */}
      {isMenuOpen && (
        <div className="absolute top-16 right-6 bg-white text-black rounded-md p-4 shadow-lg space-y-2 md:hidden">
          <Link
            to="/"
            className="block"
            onClick={() => setIsMenuOpen(false)} // Close menu on click
          >
            Home
          </Link>
          <Link
            to="/products"
            className="block"
            onClick={() => setIsMenuOpen(false)}
          >
            Products
          </Link>
          <Link
            to="/orders"
            className="block"
            onClick={() => setIsMenuOpen(false)}
          >
            My Orders
          </Link>
          <Link
            to="/go-pro"
            className="block font-bold bg-gradient-to-r from-orange-400 via-red-500 to-pink-500 bg-clip-text text-transparent"
            onClick={() => setIsMenuOpen(false)}
          >
            Get Nuvia Pro
          </Link>

        </div>
      )}
    </nav>
  );
}
